<div class="mat-typography mat-body mat-app-background">

  <h1>Register New User</h1>

  <ptl-registration
    [accountCreatedImgSrc]="accountCreatedImgSrc"
    [accountCreatedText]="accountCreatedText"
  ></ptl-registration>
</div>
